import './SearchPlaceholder.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SearchPlaceholderDefaultProps,
  SearchPlaceholderPropTypes,
} from './SearchPlaceholder.proptypes';

const SearchPlaceholder = ({ className }) => {
  const { t } = useTranslation();

  const placeholderList = ['product', 'reference', 'brand', 'range'];

  return (
    <div
      className={cn('search-placeholder', className)}
      data-qa-id="search-placeholder"
    >
      <div className="search-placeholder__label">
        {t('ebat:entities:layout.header.search.placeholder.label')}&nbsp;
      </div>
      <div className="search-placeholder__list">
        {placeholderList.map((item) => (
          <div
            className="search-placeholder__item"
            key={`search-placeholder-item-${item}`}
          >
            {t(`ebat:entities:layout.header.search.placeholder.list.${item}`)}
          </div>
        ))}
      </div>
    </div>
  );
};

SearchPlaceholder.defaultProps = {
  ...SearchPlaceholderDefaultProps,
};

SearchPlaceholder.propTypes = {
  ...SearchPlaceholderPropTypes,
};

export default SearchPlaceholder;
